import { render, staticRenderFns } from "./PassesReportList.vue?vue&type=template&id=6e5ae54b"
import script from "./PassesReportList.vue?vue&type=script&lang=js"
export * from "./PassesReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports